/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = Record<string, never>;
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        FunctionExecutionJson: {
            udfType: components["schemas"]["UdfTypeJson"];
            componentPath?: string | null;
            identifier: string;
            logLines: components["schemas"]["Value"][];
            /** Format: double */
            timestamp: number;
            cachedResult: boolean;
            caller: string;
            parentExecutionId?: string | null;
            /** Format: double */
            executionTime: number;
            /** Format: double */
            userExecutionTime?: number | null;
            success?: null | components["schemas"]["Value"];
            error?: string | null;
            requestId: string;
            executionId: string;
            usageStats: components["schemas"]["UsageStatsJson"];
            /** Format: double */
            returnBytes?: number | null;
            occInfo?: null | components["schemas"]["OccInfoJson"];
            willRetry: boolean;
            /** Format: double */
            executionTimestamp: number;
            identityType: string;
            environment: string;
            /** @enum {string} */
            kind: "Completion";
        } | {
            udfType: components["schemas"]["UdfTypeJson"];
            componentPath?: string | null;
            identifier: string;
            /** Format: double */
            timestamp: number;
            logLines: components["schemas"]["Value"][];
            requestId: string;
            executionId: string;
            /** @enum {string} */
            kind: "Progress";
        };
        /** @enum {string} */
        LogLevelJson: "DEBUG" | "ERROR" | "WARN" | "INFO" | "LOG";
        LogLineJson: {
            messages: string[];
            isTruncated: boolean;
            /** Format: int64 */
            timestamp: number;
            level: components["schemas"]["LogLevelJson"];
            systemMetadata?: null | components["schemas"]["SystemLogMetadataJson"];
            componentPath?: string | null;
            udfPath?: string | null;
        };
        OccInfoJson: {
            tableName?: string | null;
            documentId?: string | null;
            writeSource?: string | null;
            componentPath?: string | null;
            /** Format: int64 */
            retryCount?: number | null;
        };
        StreamFunctionLogs: {
            /** Format: double */
            cursor: number;
            sessionId?: string | null;
            /** Format: int32 */
            clientRequestCounter?: number | null;
        };
        StreamUdfExecutionQueryArgs: {
            /** Format: double */
            cursor: number;
        };
        StreamUdfExecutionResponse: {
            entries: components["schemas"]["FunctionExecutionJson"][];
            /** Format: double */
            newCursor: number;
        };
        SystemLogMetadataJson: {
            code: string;
        };
        /** @enum {string} */
        UdfTypeJson: "Query" | "Mutation" | "Action" | "HttpAction";
        UsageStatsJson: {
            /** Format: int64 */
            databaseReadBytes: number;
            /** Format: int64 */
            databaseWriteBytes: number;
            /** Format: int64 */
            databaseIoReadBytes: number;
            /** Format: int64 */
            databaseIoWriteBytes: number;
            /** Format: int64 */
            databaseReadDocuments: number;
            /** Format: int64 */
            databaseWriteDocuments: number;
            /** Format: int64 */
            storageReadBytes: number;
            /** Format: int64 */
            storageWriteBytes: number;
            /** Format: int64 */
            vectorIndexReadBytes: number;
            /** Format: int64 */
            vectorIndexWriteBytes: number;
            /** Format: int64 */
            textIndexQueryBytes: number;
            /** Format: int64 */
            textIndexWriteQueryBytes: number;
            /** Format: int64 */
            vectorIndexReadQueryBytes: number;
            /** Format: int64 */
            vectorIndexWriteQueryBytes: number;
            /** Format: int64 */
            networkEgressBytes: number;
            /** Format: int64 */
            memoryUsedMb: number;
        };
        Value: unknown;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type FunctionExecutionJson = components['schemas']['FunctionExecutionJson'];
export type LogLevelJson = components['schemas']['LogLevelJson'];
export type LogLineJson = components['schemas']['LogLineJson'];
export type OccInfoJson = components['schemas']['OccInfoJson'];
export type StreamFunctionLogs = components['schemas']['StreamFunctionLogs'];
export type StreamUdfExecutionQueryArgs = components['schemas']['StreamUdfExecutionQueryArgs'];
export type StreamUdfExecutionResponse = components['schemas']['StreamUdfExecutionResponse'];
export type SystemLogMetadataJson = components['schemas']['SystemLogMetadataJson'];
export type UdfTypeJson = components['schemas']['UdfTypeJson'];
export type UsageStatsJson = components['schemas']['UsageStatsJson'];
export type Value = components['schemas']['Value'];
export type $defs = Record<string, never>;
export type operations = Record<string, never>;
